import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "golf-page" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = {
  key: 0,
  class: "reserve-details"
}
const _hoisted_4 = { class: "detail-section" }
const _hoisted_5 = { class: "detail-row" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "detail-row" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "detail-row" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "detail-section" }
const _hoisted_16 = { class: "detail-row" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "detail-row" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = {
  key: 0,
  class: "actions-section"
}

import { ref, computed, onMounted } from 'vue'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import { useGolfTripsStore } from '@/store/golf-trips'
import { useGolfHeaderStore } from '@/store/golf-header'
import { useGolfI18n } from '@/composables/useGolfI18n'
import type { GolfTrip } from '@/api/golf'


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const golfStore = useGolfTripsStore()
const headerStore = useGolfHeaderStore()
const { t } = useGolfI18n()

const statusFilter = ref<string | undefined>(undefined)
const paymentStatusFilter = ref<string | undefined>(undefined)
const dateRange = ref<[Date, Date] | undefined>(undefined)
const reserveDialogVisible = ref(false)
const selectedReserve = ref<GolfTrip | null>(null)
const processingAction = ref<'approve' | 'decline' | null>(null)

const filteredReserves = computed(() => {
  return golfStore.trips.filter((reserve: GolfTrip) => {
    if (statusFilter.value && reserve.status !== statusFilter.value) return false
    if (paymentStatusFilter.value && reserve.payment_status !== paymentStatusFilter.value) return false

    if (dateRange.value && dateRange.value.length === 2) {
      const startDate = new Date(reserve.reservation_start || reserve.start_date || reserve.created_at)
      const [filterStart, filterEnd] = dateRange.value
      if (startDate < filterStart || startDate > filterEnd) return false
    }

    return true
  })
})

const applyFilters = () => {
  golfStore.fetchReserves({
    status: statusFilter.value,
    payment_method: paymentStatusFilter.value,
  })
}

const onRetryPress = () => {
  applyFilters()
}

const getRenterName = (reserve: GolfTrip) => {
  const renter = reserve.renter
  if (!renter) return '—'
  return `${renter.first_name || ''} ${renter.last_name || ''}`.trim() || '—'
}

const formatDateTime = (dateStr?: string | null) => {
  if (!dateStr) return '—'
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

const formatStatus = (status: string) => {
  const map: Record<string, string> = {
    pending: t('golf.trips.tab_pending'),
    approved: t('golf.trips.tab_approved'),
    ongoing: t('golf.trips.tab_ongoing'),
    on_hold: t('golf.trips.tab_on_hold'),
  }
  return map[status] || status
}

const getStatusType = (status: string) => {
  switch (status) {
    case 'pending':
      return 'warning'
    case 'approved':
      return 'info'
    case 'ongoing':
      return 'success'
    case 'on_hold':
      return 'warning'
    default:
      return 'info'
  }
}

const getStatusClass = (status: string) => {
  const map: Record<string, string> = {
    pending: 'status-pending',
    approved: 'status-approved',
    ongoing: 'status-ongoing',
    on_hold: 'status-on-hold',
  }
  return map[status] || ''
}

const getPaymentStatusClass = (status?: string) => {
  const map: Record<string, string> = {
    pending: 'status-pending',
    frozen: 'status-approved',
    charged: 'status-completed',
    refunded: 'status-cancelled',
  }
  return map[status || 'pending'] || ''
}

const viewReserve = (reserve: GolfTrip) => {
  selectedReserve.value = reserve
  reserveDialogVisible.value = true
}

const approveReserve = async (reserveId: string) => {
  processingAction.value = 'approve'
  try {
    await golfStore.approveTrip(reserveId)
    reserveDialogVisible.value = false
  } finally {
    processingAction.value = null
  }
}

const declineReserve = async (reserveId: string) => {
  processingAction.value = 'decline'
  try {
    await golfStore.declineTrip(reserveId)
    reserveDialogVisible.value = false
  } finally {
    processingAction.value = null
  }
}

onMounted(() => {
  headerStore.setHeaderInfo(t('golf.reserves.title'), false)
  golfStore.fetchReserves()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(golfStore).error)
      ? (_openBlock(), _createBlock(CommonError, {
          key: 0,
          errorMessage: _unref(golfStore).error,
          onRetryPress: onRetryPress
        }, null, 8, ["errorMessage"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_select, {
          modelValue: statusFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((statusFilter).value = $event)),
          placeholder: _ctx.$t('golf.fleet.filter_by_status'),
          clearable: "",
          style: {"width":"200px"},
          onChange: applyFilters
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.fleet.all'),
              value: undefined
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.tab_pending'),
              value: "pending"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.tab_approved'),
              value: "approved"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.tab_ongoing'),
              value: "ongoing"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.tab_on_hold'),
              value: "on_hold"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_select, {
          modelValue: paymentStatusFilter.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentStatusFilter).value = $event)),
          placeholder: _ctx.$t('golf.reserves.filter_payment'),
          clearable: "",
          style: {"width":"200px"},
          onChange: applyFilters
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.fleet.all'),
              value: undefined
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.tab_pending'),
              value: "pending"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.trips.freeze_amount'),
              value: "frozen"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.financial.charged'),
              value: "charged"
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('golf.financial.refunded'),
              value: "refunded"
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_el_date_picker, {
          modelValue: dateRange.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateRange).value = $event)),
          type: "daterange",
          "range-separator": "-",
          "start-placeholder": _ctx.$t('golf.dashboard.start_date'),
          "end-placeholder": _ctx.$t('golf.dashboard.end_date'),
          style: {"width":"300px"},
          onChange: applyFilters
        }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: filteredReserves.value,
        style: {"width":"100%"},
        class: "reserves-table"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: "ID",
            "min-width": "120"
          }),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.trips.renter_profile'),
            "min-width": "150"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(getRenterName(row)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.trips.vehicle_model'),
            "min-width": "150"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.golf_car_profile?.name || '—'), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.dashboard.start_date'),
            "min-width": "160"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(formatDateTime(row.reservation_start || row.trip_start_at)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.dashboard.end_date'),
            "min-width": "160"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(formatDateTime(row.reservation_end || row.trip_end_at)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.status'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                class: _normalizeClass(getStatusClass(row.status))
              }, _toDisplayString(formatStatus(row.status)), 3)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.trips.payment_status'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                class: _normalizeClass(getPaymentStatusClass(row.payment_status))
              }, _toDisplayString((row.payment_status || 'pending').toUpperCase()), 3)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.common.amount'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(" ₼" + _toDisplayString((row.total_amount || 0).toFixed(2)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('golf.trips.actions'),
            "min-width": "120"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                size: "small",
                onClick: ($event: any) => (viewReserve(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('golf.fleet.view')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(golfStore).isLoading]
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: reserveDialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((reserveDialogVisible).value = $event)),
      title: `Reserve: ${selectedReserve.value?.id}`,
      width: "60%"
    }, {
      default: _withCtx(() => [
        (selectedReserve.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.reserves.title')), 1),
                        _createElementVNode("div", _hoisted_5, [
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "ID:", -1)),
                          _createElementVNode("span", _hoisted_6, _toDisplayString(selectedReserve.value.id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('golf.common.status')) + ":", 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(getStatusClass(selectedReserve.value.status))
                          }, _toDisplayString(formatStatus(selectedReserve.value.status)), 3)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('golf.dashboard.start_date')) + ":", 1),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(formatDateTime(
                  selectedReserve.value.reservation_start ||
                    selectedReserve.value.start_date
                )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('golf.dashboard.end_date')) + ":", 1),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(formatDateTime(
                  selectedReserve.value.reservation_end || selectedReserve.value.end_date
                )), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.trips.renter_profile')) + " & " + _toDisplayString(_ctx.$t('golf.fleet.title')), 1),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('golf.financial.renter')) + ":", 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(selectedReserve.value.user_id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('golf.trips.vehicle_model')) + ":", 1),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(selectedReserve.value.golf_car_profile_id), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('golf.trips.payment_status')) + ":", 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(getPaymentStatusClass(selectedReserve.value.payment_status))
                          }, _toDisplayString((selectedReserve.value.payment_status || 'pending').toUpperCase()), 3)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('golf.common.amount')) + ":", 1),
                          _createElementVNode("span", _hoisted_26, "₼" + _toDisplayString((selectedReserve.value.total_amount || 0).toFixed(2)), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (selectedReserve.value.status === 'pending')
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_el_button, {
                      type: "success",
                      loading: processingAction.value === 'approve',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (approveReserve(selectedReserve.value.id)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.trips.approve')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      loading: processingAction.value === 'decline',
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (declineReserve(selectedReserve.value.id)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.trips.decline')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})